const server = {
  state: {
      isLogin:false,
      vPid: NaN,
  },
  mutations: {
    setIsLogin (state, data) {
      state.isLogin = data
    },
    setVPid(state,data){
      state.vPid = data
    }
  },
  actions: {

  }
}

export default server



// WEBPACK FOOTER //
// ./src/store/modules/server.js